<template>
	<x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="closeDialog">知道啦</a>
        </div>
      </x-dialog>
</template>
<script>
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
export default{
	props:{
		showStatus:Number,
		tipText:String
	},
	data(){
		return {
			
		}
	},
	components:{
	   XDialog
	},
	computed:{
		tipDialog(){
			if(this.showStatus!=0){
				return true;
			}else{
				return false;
			}
		}
	},
	methods:{
		closeDialog(){
			this.$emit('close',0)
		}
	}
}
</script>